import React from 'react';
import './TransportBreakdown.css';

// Sub-score breakdown for the Transport & Connectivity detail hero.
// Reads the factor shape from dataShape.js:
//
//   sub:   { bus: 68, road: 80, airport: 74, walk: 62 }
//   facts: [
//     "23 buses/day within 400m",
//     "6 min to A1 motorway",
//     "28 min to Larnaca airport",
//     "Walkable for daily errands",
//   ]
//
// Bars and facts are paired by index — keep the order:
//   0 = Bus service, 1 = Road & highway, 2 = Airport proximity, 3 = Walkability.
//
// Labels are the component's own mapping of the sub-score keys ('bus',
// 'road', 'airport', 'walk') — the underlying data carries only numbers, so
// the label naming is the component's responsibility. These names match
// what the dataShape's facts strings describe.
export default function TransportBreakdown({ sub, facts }) {
  if (!sub) return null;
  const rows = [
    { key: 'bus',     label: 'Bus service',       score: sub.bus,     hint: facts?.[0] },
    { key: 'road',    label: 'Road & highway',    score: sub.road,    hint: facts?.[1] },
    { key: 'airport', label: 'Airport proximity', score: sub.airport, hint: facts?.[2] },
    { key: 'walk',    label: 'Walkability',       score: sub.walk,    hint: facts?.[3] },
  ];

  return (
    <div className="nd-transport-bd">
      <div className="nd-transport-bd__title">Sub-scores · 0–100 scale</div>

      <div className="nd-transport-bd__rows">
        {rows.map(r => (
          <div key={r.key} className="nd-transport-bd__row">
            <div className="nd-transport-bd__row-label" title={r.label}>{r.label}</div>
            <div className="nd-transport-bd__row-bar-col">
              <div className="nd-transport-bd__bar" role="presentation">
                <div
                  className="nd-transport-bd__bar-fill"
                  style={{ width: `${Math.max(0, Math.min(100, r.score ?? 0))}%` }}
                />
              </div>
              {r.hint && <div className="nd-transport-bd__row-hint">{r.hint}</div>}
            </div>
            <div className="nd-transport-bd__row-score">{r.score ?? '—'}</div>
          </div>
        ))}
      </div>

      {/* X-axis indicator — the spacer columns on left/right match the
          label/score column widths in each row so the 0/100 ticks line up
          exactly with the bars above. */}
      <div className="nd-transport-bd__axis" aria-hidden="true">
        <div className="nd-transport-bd__axis-spacer-left" />
        <div className="nd-transport-bd__axis-track">
          <div className="nd-transport-bd__axis-ticks">
            <span>0</span>
            <span>100</span>
          </div>
          <div className="nd-transport-bd__axis-rule" />
        </div>
        <div className="nd-transport-bd__axis-spacer-right" />
      </div>
    </div>
  );
}
